export default "__VITE_ASSET__DAq3UQp8__"